import MapWithIcons from "./MapWithIcons"

export default  MapWithIcons;



// WEBPACK FOOTER //
// ./src/common/components/MapWithIcons/index.js